import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import {
  AdrStoreActions,
  AdrStoreSelectors,
  AdrStoreReducer,
} from "./index";
import { AdrDto } from "@cradua/data";

@Injectable()
export class AdrFacade {
  constructor(
    private store: Store<AdrStoreReducer.AdrPartialState>,
  ) {}

  Adr$ = this.store.select(
    AdrStoreSelectors.getLastInsertedValue,
  );
  AdrError$ = this.store.select(
    AdrStoreSelectors.getAdrError,
  );
  searchedAdr$ = this.store.select(
    AdrStoreSelectors.getSearchAdr,
  );

  loadRegister$ = this.store.select(
    AdrStoreSelectors.getAllAdr,
  );

  // return this.store.select(AdrStoreSelectors.getAllAdr);

  getselected() {
    return this.store.select(AdrStoreSelectors.getSelected);
  }

  isLoadingAdr(query) {
    this.store.dispatch(
      AdrStoreActions.fetchAdrRecord({ fetch: query }),
    );
    return this.store.select(AdrStoreSelectors.loadingAdr);
  }

  isLoadingAdrById(id: string) {

    this.store.dispatch(
      AdrStoreActions.fetchByIdAdrRecord({ id }),
    );
    return this.store.select(AdrStoreSelectors.loadingAdr);
  }

  get loadAdr() {
    this.store.dispatch(AdrStoreActions.loadAdr());
    return this.store.select(AdrStoreSelectors.getAllAdr);
  }

  get clearAdr() {
    this.store.dispatch(AdrStoreActions.clearAdr());
    return this.store.select(AdrStoreSelectors.getAllAdr);
  }

  fetchStudentRecord(query) {
    this.store.dispatch(
      AdrStoreActions.fetchAdrRecord({ fetch: query }),
    );
  }

  fetchByIdStudentRecord(id: string) {
    this.store.dispatch(
      AdrStoreActions.fetchByIdAdrRecord({ id }),
    );
  }

  searchAdr(query) {
    this.store.dispatch(
      AdrStoreActions.searchAdrRecord({
        query,
      }),
    );
  }

  findAdr(query) {
    this.store.dispatch(
      AdrStoreActions.searchAdrIdRecord({
        query,
      }),
    );
  }

  addAdr(newAdr: AdrDto) {
    this.store.dispatch(
      AdrStoreActions.addAdr({
        newAdr,
      }),
    );
  }

  updateAdr(updateAdr: AdrDto) {
    this.store.dispatch(
      AdrStoreActions.updateAdr({
        updateAdr,
      }),
    );
  }

  removeAdr(id: string) {
    this.store.dispatch(AdrStoreActions.removeAdr({ id }));
  }
}